import { File } from "../../expense/file";

export class responseGetExpenseFiles {
    list:Array<File>;
    constructor (data) {
        this.list = data.files.map(item => new File(item));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-get-expense-files.ts